import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'admin-ai-flow',
    template: require('./admin.ai-flow.html')
})
export class AdminAiFlowComponent implements OnInit {

    constructor(private titleService: Title) {}

    ngOnInit(): void {
        this.titleService.setTitle('AI Flow Settings');
    }
}
